import { Component, Vue, Watch } from "vue-property-decorator";
import {
	CategoryResponseModel,
	CategoryManagerService,
	EditCategoryRequestModel,
	EditTypeRequestModel,
	CreateCategoryRequestModel,
	CreateTypeRequestModel,
	TypeResponseModel
} from "@/services/category-manager";
import { Icon, Button, Tag, Modal, Input, Checkbox, FormModel, Select, Alert, Form, Table } from "ant-design-vue";
import { v4 } from "uuid";
import { Action, ActionItem, fmtMsg, MessageHelper, NotificationType, ServerExceptionCode } from "commonui";
import { CategoryManagerLocale, MediaLocale } from "@/locales/localeid";
import { getModule } from "vuex-module-decorators";
import CategoryManagerState from "@/modules/category-manager";
import PageTitle from "@/components/page-title/page-title.vue";
import { ContentGroupEnum, CurriculumType, MediaSlot, SpecialDesignation } from "@/util/enum";
import { AccessLevel } from "@/util/enum";
import { disabledDueToAccessLevel, getRouteAccessLevel } from "@/util/func";
import TitleListState from "@/modules/title-list";

const AssociateLessonPlanNone = "-1";
@Component({
	components: {
		Icon,
		Button,
		Tag,
		Modal,
		Input,
		Checkbox,
		Form: FormModel,
		FormItem: FormModel.Item,
		Select,
		SelectOption: Select.Option,
		Action,
		ActionItem,
		PageTitle,
		Alert,
		Table
	}
})
export default class CategoryManager extends Vue {
	private categoryService = CategoryManagerService();
	private categoriesModule = getModule(CategoryManagerState);
	public categories: CategoryResponseModel[] = [];
	public newTypeCategoryId: number = -1; // category id for which type is created.
	public typeModalCatName: string = "";
	public isDisabled: boolean = false;
	public createModalVisible: boolean = false;
	public createSubCategoryModalVisible: boolean = false;
	public labelCol = { span: 9 };
	public wrapperCol = { span: 13 };
	public createModalTitle = "";
	public isTeachingPlanEnabled = false;
	public isManageLessonPlanEnabled = false;
	public isCurriculumComponent = false;

	public forceVcsInteral = false;
	public forceDisabled = false;
	public editModalVisible = false;
	public editSubCategoryModalVisible = false;
	public editModalTitle = "";
	public editModalDisable = "";
	public editedCategoryId = -1;
	public editedTypeId = -1;

	public removeAssociationModalVisible = false;
	public str: any = "";
	public removeAssociation: any = [];
	public removeAssociationTableColumns: any[] = [
		{
			title: "Unit",
			dataIndex: "unit",
			key: "unit",
			width: "30%"
		},
		{
			title: "Component",
			dataIndex: "component",
			key: "component",
			width: "70%"
		}
	];

	public format = fmtMsg;
	public Locale = CategoryManagerLocale;
	public accessLevel = AccessLevel;
	private titleListModule = getModule(TitleListState);

	ModalType = {
		None: -1,
		Type: 0,
		Category: 1
	};

	public enableSaveButton = false;
	public saveButtonLoading = false;
	public beingEditedOrCreated = this.ModalType.None; // 0 for type, 1 for category
	public typeDocsCount = -1;
	public loadingTypeDocsCount = false;
	public moveButtonLoading = false;
	public showRepDeleteMsg = false;
	public showLessonPlanDeleteMsg = false;
	public showLessonRelatedItemsDeleteMsg = false;
	public checkboxValidationState = {
		isUnitBasedError: false,
		isCurriculumError: false
	};
	public isSpecialDesignationDropdownVisible = false;

	public deleteMode = false;

	public createForm = {
		name: "",
		isVCSInternal: false,
		allowTeachingPlan: false,
		isExternal: false,
		isUnitBased: false,
		isCurriculum: false,
		isLessonManagement: false
	};

	public subCategoryCreateForm = {
		name: "",
		isVCSInternal: false,
		isExternal: false,
		isMultiLingual: false,
		isLessonRelatedItem: false,
		contentGroupId: -1,
		allowRepPlan: false,
		downloadMediaSlotId: -1,
		showLabelInLessonPlan: this.isCurriculumComponent,
		lessonPlanVersionId: AssociateLessonPlanNone,
		specialDesignationId: 1,
		isSupportResource: false
	};

	public createFormRules = {
		name: [
			{
				required: true,
				message: fmtMsg(CategoryManagerLocale.CategoryManagerCreateNameRequired),
				trigger: "change"
			},
			{ validator: this.uniqueNameValidator, trigger: "change" },
			{ validator: this.checkInitialSpaceValidator, trigger: "change" }
		]
	};

	public disableHelp = "";

	public editForm = {
		name: "",
		disabled: false,
		isVCSInternal: false,
		isExternal: false,
		allowTeachingPlan: false,
		allowRepPlan: false,
		isUnitBased: false,
		isCurriculum: false,
		isLessonManagement: false,
		isAbleToManageLesson: false,
		hasContents: false
	};

	public subCategoryEditForm = {
		name: "",
		disabled: false,
		isVCSInternal: false,
		isExternal: false,
		isMultiLingual: false,
		isLessonRelatedItem: false,
		contentGroupId: -1,
		allowRepPlan: false,
		isSupportResource: false,
		downloadMediaSlotId: -1,
		showLabelInLessonPlan: false,
		lessonPlanVersionId: AssociateLessonPlanNone,
		specialDesignationId: 1
	};

	public formRules = {
		name: [
			{
				required: true,
				message: fmtMsg(CategoryManagerLocale.CategoryManagerEditNameRequired),
				trigger: "change"
			},
			{ validator: this.uniqueNameValidator, trigger: "change" },
			{ validator: this.checkInitialSpaceValidator, trigger: "change" }
		],
		contentGroupId: [{ validator: this.validateContentGroup, trigger: "change" }]
	};

	public moveForm = {
		categoryId: undefined,
		typeId: undefined
	};

	public moveFormRules = {
		categoryId: [
			{ required: true, message: fmtMsg(CategoryManagerLocale.CategoryManagerMoveChooseCat), trigger: "blur" }
		],
		typeId: [
			{ required: true, message: fmtMsg(CategoryManagerLocale.CategoryManagerMoveChooseType), trigger: "blur" }
		]
	};

	public contentGroupOptions = [
		{
			id: -1,
			locale: CategoryManagerLocale.CategoryManagerContentGroupNone
		},
		{
			id: 0,
			locale: CategoryManagerLocale.CategoryManagerContentGroupSong
		},
		{
			id: 1,
			locale: CategoryManagerLocale.CategoryManagerContentGroupMovie
		},
		{
			id: 2,
			locale: CategoryManagerLocale.CategoryManagerContentGroupStory
		},
		{
			id: 5,
			locale: CategoryManagerLocale.CategoryManagerContentGroupVpc
		}
	];

	public mediaSlotOptions = [
		{
			id: -1,
			locale: CategoryManagerLocale.CategoryManagerMediaSlotNone
		},
		{
			id: MediaSlot.ViewingContent,
			locale: MediaLocale.MediaViewingContentText
		},
		{
			id: MediaSlot.AlternateContent,
			locale: MediaLocale.MediaAlternateContentText
		},
		{
			id: MediaSlot.Audio,
			locale: MediaLocale.MediaAudioText
		},
		{
			id: MediaSlot.AudioBackground,
			locale: MediaLocale.MediaAudioBackgroundText
		},
		{
			id: MediaSlot.StreamingVideo,
			locale: MediaLocale.MediaStreamingVideoText
		},
		{
			id: MediaSlot.OfflineVideo,
			locale: MediaLocale.MediaOfflineVideoText
		},
		{
			id: MediaSlot.TeacherManual,
			locale: MediaLocale.MediaTeacherManualText
		},
		{
			id: MediaSlot.Thumbnail,
			locale: MediaLocale.MediaThumbnailText
		}
	];

	public specialDesignations = [
		{
			id: 1,
			locale: CategoryManagerLocale.CategoryManagerSpecialDesignationNone
		},
		{
			id: 2,
			locale: CategoryManagerLocale.CategoryManagerSpecialDesignationVPC
		},
		{
			id: 3,
			locale: CategoryManagerLocale.CategoryManagerSpecialDesignationVPCReview
		},
		{
			id: 4,
			locale: CategoryManagerLocale.CategoryManagerSpecialDesignationLetterPhonogram
		},
		{
			id: 5,
			locale: CategoryManagerLocale.CategoryManagerSpecialDesignationPhonogramWordCard
		},
		{
			id: 6,
			locale: CategoryManagerLocale.CategoryManagerSpecialDesignationFocusWords
		}
	];

	get locale() {
		return CategoryManagerLocale;
	}

	get associateLessonPlanNone() {
		return AssociateLessonPlanNone;
	}

	get availableCategory() {
		// if category have more than one type, then allow to move to same category another type
		const category = this.categories.find((cat) => cat.id === this.editedCategoryId && !cat.isLessonManagement);
		if ((category?.types.length as number) > 1) {
			return this.categories.filter((cat) => cat.isCurriculum === category?.isCurriculum && cat.isUnitBased === category?.isUnitBased && !cat.disabled);
		} else {
			return this.categories.filter((cat) => cat.id != this.editedCategoryId && cat.isCurriculum === category?.isCurriculum && cat.isUnitBased === category?.isUnitBased && !cat.isLessonManagement && !cat.disabled);
		}
	}

	get createLabel() {
		return this.beingEditedOrCreated === this.ModalType.Type
			? fmtMsg(CategoryManagerLocale.CategoryManagerCreateTypeLabel)
			: fmtMsg(CategoryManagerLocale.CategoryManagerCreateCatLabel);
	}

	get currentRouteAccessLevel() {
		return getRouteAccessLevel(this.$route);
	}

	get disabledDueToAccessLevel() {
		return disabledDueToAccessLevel(this.currentRouteAccessLevel);
	}

	availableTypes = [];

	@Watch("moveForm.categoryId")
	updateTypes() {
		this.availableTypes = this.categories
			.find((cat) => cat.id === this.moveForm.categoryId)
			?.types.filter((t) => t.id !== this.editedTypeId && t.specialDesignationId === this.subCategoryEditForm.specialDesignationId) as any;
	}

	mounted() {
		const cats = this.categoriesModule.categories;
		this.categories = Array.isArray(cats) ? cats : [];
	}

	fetchCategories() {
		return this.categoriesModule.fetchCategories().then(() => {
			const cats = this.categoriesModule.categories;
			this.categories = cats.map((cat: any) => {
				cat.tempId = v4(); // vue doen't re-render with simple assignment. so needed to create tempId
				return cat as any;
			});
			return Promise.resolve();
		});
	}

	validatedCreateOrEditForm(item: string, isPassed: boolean, error: string) {
		if (isPassed != this.enableSaveButton) this.enableSaveButton = isPassed;
	}

	uniqueNameValidator(rule: any, value: string, callback: (msg?: string) => void) {
		if (this.beingEditedOrCreated === this.ModalType.Type) {
			if (this.editModalVisible) {
				const types = this.categories.find((c) => c.id === this.editedCategoryId)?.types;
				if (
					types &&
					types.find(
						(t) => t.name.trim().toLowerCase() === value.trim().toLowerCase() && t.id !== this.editedTypeId
					)
				) {
					callback(fmtMsg(CategoryManagerLocale.CategoryManagerCreateEditTypeUnique));
					return;
				}
				callback();
			} else {
				// means create modal opened
				const types = this.categories.find((c) => c.id === this.newTypeCategoryId)?.types;
				if (types && types.find((t) => t.name.trim().toLowerCase() === value.trim().toLowerCase())) {
					callback(fmtMsg(CategoryManagerLocale.CategoryManagerCreateEditTypeUnique));
					return;
				}
				callback();
			}
		} else {
			// Category is being edited
			if (this.editModalVisible) {
				if (
					this.categories.find(
						(c) =>
							c.name.trim().toLowerCase() === value.trim().toLowerCase() && c.id !== this.editedCategoryId
					)
				) {
					callback(fmtMsg(CategoryManagerLocale.CategoryManagerCreateEditCatUnique));
					return;
				}
				callback();
			} else {
				if (this.categories.find((c) => c.name.trim().toLowerCase() === value.trim().toLowerCase())) {
					callback(fmtMsg(CategoryManagerLocale.CategoryManagerCreateEditCatUnique));
					return;
				}
				callback();
			}
		}
		callback();
	}

	checkInitialSpaceValidator(rule: any, value: string, callback: (msg?: string) => void) {
		if (!value.trim().length) {
			callback(fmtMsg(CategoryManagerLocale.CategoryManagerCreateNameRequired));
		}
		callback();
	}

	validateContentGroup(rule: any, value: number, callback: (msg?: string) => void) {
		if (this.beingEditedOrCreated === this.ModalType.Type) {
			if (this.isContentGroupInValid()) {
				callback(this.$format(CategoryManagerLocale.CategoryManagerContentGroupValidationMsg));
			} else {
				callback();
			}
		} else {
			callback();
		}
	}

	isContentGroupInValid() {
		const isInValid =
			(this.editSubCategoryModalVisible &&
				this.subCategoryEditForm.allowRepPlan &&
				(isNaN(this.subCategoryEditForm.contentGroupId) || this.subCategoryEditForm.contentGroupId === -1)) ||
			(this.createSubCategoryModalVisible &&
				this.subCategoryCreateForm.allowRepPlan &&
				(isNaN(this.subCategoryEditForm.contentGroupId) || this.subCategoryCreateForm.contentGroupId === -1));

		return isInValid;
	}

	changeContentGroup() {
		this.onEditingSubCategory();
		let category: CategoryResponseModel | undefined = undefined;
		let contentGroupId = 0;

		if (this.editSubCategoryModalVisible) {
			category = this.categories.find((c) => c.id === this.editedCategoryId);
			contentGroupId = this.subCategoryEditForm.contentGroupId;
			if(contentGroupId === ContentGroupEnum.VPC) {
				this.subCategoryEditForm.specialDesignationId = SpecialDesignation.VPC;
			}
			else {
				this.subCategoryEditForm.specialDesignationId = SpecialDesignation.None;
			}
		} else if (this.createSubCategoryModalVisible) {
			category = this.categories.find((c) => c.id === this.newTypeCategoryId);
			contentGroupId = this.subCategoryEditForm.contentGroupId;
			if(contentGroupId === ContentGroupEnum.VPC) {
				this.subCategoryEditForm.specialDesignationId = SpecialDesignation.VPC;
			}
			else {
				this.subCategoryEditForm.specialDesignationId = SpecialDesignation.None;
			}
		}		
	}

	changeSpecialDesignation() {
		this.onEditingSubCategory();
		let category: CategoryResponseModel | undefined = undefined;
		let specialDesignationId = 0;

		if (this.editSubCategoryModalVisible) {
			category = this.categories.find((c) => c.id === this.editedCategoryId);
			specialDesignationId = this.subCategoryEditForm.specialDesignationId;
			if(specialDesignationId === SpecialDesignation.VPC || specialDesignationId === SpecialDesignation.ReviewVPC) {
				this.subCategoryEditForm.contentGroupId = ContentGroupEnum.VPC;
			}
			else {
				this.subCategoryEditForm.contentGroupId = ContentGroupEnum.None;
			}
		} else if (this.createSubCategoryModalVisible) {
			category = this.categories.find((c) => c.id === this.newTypeCategoryId);
			specialDesignationId = this.subCategoryCreateForm.specialDesignationId;
			if(specialDesignationId === SpecialDesignation.VPC || specialDesignationId === SpecialDesignation.ReviewVPC) {
				this.subCategoryCreateForm.contentGroupId = ContentGroupEnum.VPC;
			}
			else {
				this.subCategoryCreateForm.contentGroupId = ContentGroupEnum.None;
			}
		}		
	}

	onCreateModalClose() {
		const form = this.$refs.createForm as FormModel;
		const subCategoryform = this.$refs.subCategoryCreateForm as FormModel;

		this.createModalVisible = false;
		this.createSubCategoryModalVisible = false;
		this.newTypeCategoryId = -1;
		setTimeout(() => {
			this.createModalTitle = "";
			this.typeModalCatName = "";
			this.saveButtonLoading = false;
			this.forceVcsInteral = false;
		}, 200);

		if (form && form.resetFields) {
			form.resetFields();
		}
		if (subCategoryform && subCategoryform.resetFields) {
			subCategoryform.resetFields();
		}
	}

	showCreateModal(
		catId?: string,
		catName?: string,
		isCatExternal?: boolean,
		allowTeachingPlan?: boolean,
		isManageLessonPlan?: boolean,
		isCurriculum?: boolean,
		isUnitBased?: boolean
	) {
		this.createModalTitle = fmtMsg(CategoryManagerLocale.CategoryManagerCreateCatModalTitle);
		this.beingEditedOrCreated = this.ModalType.Category;
		if (typeof catId === "number") {
			// create type
			this.subCategoryCreateForm.isExternal = isCatExternal as boolean;
			this.forceVcsInteral = !isCatExternal as boolean;
			this.beingEditedOrCreated = this.ModalType.Type;
			this.newTypeCategoryId = catId;
			this.typeModalCatName = catName as string;
			this.createModalTitle = fmtMsg(CategoryManagerLocale.CategoryManagerCreateTypeModalTitle);
			this.isTeachingPlanEnabled = allowTeachingPlan as boolean;
			this.isManageLessonPlanEnabled = isManageLessonPlan as boolean;
			this.createSubCategoryModalVisible = true;
			this.isSpecialDesignationDropdownVisible = !isManageLessonPlan as boolean && isCurriculum as boolean && isUnitBased as boolean && allowTeachingPlan as boolean;
		} else {
			this.createModalVisible = true;
		}

		this.enableSaveButton = false;
	}

	isCategoryUnitBased(categoryId: number) {
		return this.categories.find(c => c.id === categoryId)?.isUnitBased
	}

	createNewTypeOrCategory() {
		if (this.beingEditedOrCreated === this.ModalType.Type) {
			const form = this.$refs.subCategoryCreateForm as FormModel;
			form.validate((valid) => {
				if (valid) {
					this.saveButtonLoading = true;
					if (this.beingEditedOrCreated === this.ModalType.Type) {
						// create type
						const createTypeRequestModel: CreateTypeRequestModel = {
							...this.subCategoryCreateForm,
							contentCategoryId: this.newTypeCategoryId,
							downloadMediaSlotId:
								this.subCategoryCreateForm.downloadMediaSlotId === -1
									? null
									: (this.subCategoryCreateForm.downloadMediaSlotId as MediaSlot),
							lessonPlanVersionId:
								this.subCategoryCreateForm.lessonPlanVersionId === AssociateLessonPlanNone
									? null
									: this.subCategoryCreateForm.lessonPlanVersionId,
							isUnitBased: this.isCategoryUnitBased(this.newTypeCategoryId)
						} as CreateTypeRequestModel;
						this.categoryService
							.createType(createTypeRequestModel as CreateTypeRequestModel)
							.then(() =>
								this.fetchCategories().then(() => {
									this.onCreateModalClose();
									MessageHelper.Message(
										NotificationType.Success,
										fmtMsg(CategoryManagerLocale.CategoryManagerCreateTypeSuc)
									);
								})
							)
							.catch(() => {
								this.saveButtonLoading = false;
								MessageHelper.Message(
									NotificationType.Failed,
									fmtMsg(CategoryManagerLocale.CategoryManagerCreateTypeFail)
								);
							});
					}
				}
			});
		} else {
			const form = this.$refs.createForm as FormModel;
			form.validate((valid) => {
				if (valid) {
					this.saveButtonLoading = true;
					const createTypeOrCatModel: CreateCategoryRequestModel = {
						...this.createForm
					} as CreateCategoryRequestModel;
					// create category
					this.categoryService
						.createCategory(createTypeOrCatModel)
						.then(() => {
							this.fetchCategories().then(() => {
								this.onCreateModalClose();
								MessageHelper.Message(
									NotificationType.Success,
									fmtMsg(CategoryManagerLocale.CategoryManagerCreateCatSuc)
								);
							});
						})
						.catch(() => {
							this.saveButtonLoading = false;
							MessageHelper.Message(
								NotificationType.Failed,
								fmtMsg(CategoryManagerLocale.CategoryManagerCreateCatFail)
							);
						});
				}
			});
		}
	}

	showEditModal(cat: CategoryResponseModel, type?: TypeResponseModel) {
		this.editModalTitle = fmtMsg(CategoryManagerLocale.CategoryManagerEditCatModalTitle);
		this.editModalDisable = fmtMsg(CategoryManagerLocale.CategoryManagerLabelDisCat);
		this.beingEditedOrCreated = this.ModalType.Category;
		this.editedCategoryId = cat.id;
		const isCatExternal = cat.isExternal;
		const isCatDisabled = cat.disabled;
		this.checkboxValidationState.isUnitBasedError = false;
		this.checkboxValidationState.isCurriculumError = false;
		// for edit
		if (type && type.id) {
			const isExternal = type.isExternal;
			const disabled = type.disabled;
			this.subCategoryEditForm.name = type.name;
			this.subCategoryEditForm.isExternal = !isCatExternal ? (isCatExternal as boolean) : (isExternal as boolean);
			this.subCategoryEditForm.disabled = disabled;
			this.subCategoryEditForm.contentGroupId = type.contentGroupId as number;
			this.subCategoryEditForm.isLessonRelatedItem = type.isLessonRelatedItem;
			this.subCategoryEditForm.showLabelInLessonPlan = this.isCurriculumComponent
				? type.showLabelInLessonPlan
				: false;
			this.subCategoryEditForm.isMultiLingual = type.isMultiLingual;
			this.subCategoryEditForm.allowRepPlan = this.isCurriculumComponent ? type.allowRepPlan : false;
			this.subCategoryEditForm.isSupportResource = type.isSupportResource;
			this.subCategoryEditForm.specialDesignationId = type.specialDesignationId;
			this.subCategoryEditForm.lessonPlanVersionId = type.lessonPlanVersionId
				? (type.lessonPlanVersionId as any)
				: AssociateLessonPlanNone;
			this.subCategoryEditForm.downloadMediaSlotId = type.downloadMediaSlotId
				? (type.downloadMediaSlotId as number)
				: -1;
			this.forceVcsInteral = !isCatExternal as boolean;
			this.subCategoryEditForm.disabled = isCatDisabled ? isCatDisabled : disabled;
			this.forceDisabled = isCatDisabled as boolean;
			this.editModalDisable = fmtMsg(CategoryManagerLocale.CategoryManagerLabelDisType);
			this.editModalTitle = fmtMsg(CategoryManagerLocale.CategoryManagerEditTypeModalTitle);
			this.beingEditedOrCreated = this.ModalType.Type;
			this.editedTypeId = type.id;
			this.typeModalCatName = cat.name as string;
			this.isTeachingPlanEnabled = cat.allowTeachingPlan as boolean;
			this.isManageLessonPlanEnabled = cat.isLessonManagement as boolean;
			this.isCurriculumComponent = cat.isCurriculum as boolean;
			this.isSpecialDesignationDropdownVisible = cat.isCurriculum && cat.isUnitBased && cat.allowTeachingPlan
			this.editSubCategoryModalVisible = true;
		} else {
			this.editForm.name = cat.name;
			this.editForm.isExternal = isCatExternal;
			this.editForm.disabled = cat.disabled;
			this.editModalVisible = true;
			this.editForm.allowTeachingPlan = cat.allowTeachingPlan;
			this.editForm.isCurriculum = cat.isCurriculum;
			this.editForm.isUnitBased = cat.isUnitBased;
			this.editForm.isLessonManagement = cat.isLessonManagement;
			this.editForm.isAbleToManageLesson = cat.isUnitBased;
			this.editForm.hasContents = cat.hasContents;
		}

		this.disableHelp =
			this.beingEditedOrCreated === this.ModalType.Type
				? fmtMsg(CategoryManagerLocale.CategoryManagerEditDisableTypeWarn)
				: fmtMsg(CategoryManagerLocale.CategoryManagerEditDisableCatWarn);
	}

	onEditModalClose() {
		setTimeout(() => {
			this.editModalTitle = "";
			this.deleteMode = false;
			this.saveButtonLoading = false;
			this.moveButtonLoading = false;
			this.editedCategoryId = -1;
			this.typeDocsCount = -1;
			this.forceVcsInteral = false;
			this.forceDisabled = false;
			this.showRepDeleteMsg = false;
			this.showLessonPlanDeleteMsg = false;
			this.showLessonRelatedItemsDeleteMsg = false;
			const editForm = (this.editModalVisible
				? this.$refs.editForm
				: this.$refs.subCategoryEditForm) as FormModel;
			editForm.clearValidate([]); // clear previous validation if present.
		}, 200);
		this.editModalVisible = false;
		this.editSubCategoryModalVisible = false;
		this.editedTypeId = -1;
		this.loadingTypeDocsCount = false;
		this.moveForm.typeId = undefined;
		this.moveForm.categoryId = undefined;
		this.enableSaveButton = false;
	}

	onRemoveAssociationModalOk() {
		this.removeAssociationModalVisible = false;
		this.removeAssociation = [];
	}

	onSupportResourceChangeAtCreate(e) {
		if (e.target.checked) {
			this.subCategoryCreateForm.allowRepPlan = false;
			this.subCategoryCreateForm.isLessonRelatedItem = false;
		}
	}

	onSupportResourceChangeAtEdit(e) {
		this.onEditingSubCategory();
		if (e.target.checked) {
			this.subCategoryEditForm.allowRepPlan = false;
			this.subCategoryEditForm.isLessonRelatedItem = false;
		}
	}

	editTypeOrCategory() {
		if (this.beingEditedOrCreated === this.ModalType.Type) {
			const form = this.$refs.subCategoryEditForm as FormModel;
			form.validate((valid: boolean & any, obj: any) => {
				if (valid) {
					this.saveButtonLoading = true;
					if (this.beingEditedOrCreated === this.ModalType.Type) {
						const model: EditTypeRequestModel = {
							categoryId: this.editedCategoryId,
							id: this.editedTypeId,
							...this.subCategoryEditForm,
							downloadMediaSlotId:
								this.subCategoryEditForm.downloadMediaSlotId === -1
									? null
									: (this.subCategoryEditForm.downloadMediaSlotId as MediaSlot),
							lessonPlanVersionId:
								this.subCategoryEditForm.lessonPlanVersionId === AssociateLessonPlanNone
									? null
									: this.subCategoryEditForm.lessonPlanVersionId,
							isUnitBased: this.isCategoryUnitBased(this.editedCategoryId),
							specialDesignationId: this.subCategoryEditForm.specialDesignationId
						};
						this.categoryService
							.editType(model)
							.then(() =>
								this.fetchCategories().then(() => {
									this.onEditModalClose();
									MessageHelper.Message(
										NotificationType.Success,
										fmtMsg(CategoryManagerLocale.CategoryManagerEditTypeSuc)
									);
								})
							)
							.catch((err) => {
								this.saveButtonLoading = false;

								if (err.error_code == ServerExceptionCode.RemoveUnitComponentException) {
									this.str = err.body.error_description[0];
									this.str = this.str.replace("Error:", " ");
									this.str = JSON.parse(this.str);

									this.str.forEach((ele: any) => {
										const dataItem = {
											component: ele.Title,
											unit: ele.Unit,
											key: ele.UnitId
										};
										this.removeAssociation.push(dataItem);
									});

									this.removeAssociationModalVisible = true;
									MessageHelper.Message(
										NotificationType.Warning,
										fmtMsg(CategoryManagerLocale.CategoryManagerSubCategoryEditWarning, {
											subCategoryName: model.name
										})
									);
								} else {
									MessageHelper.Message(
										NotificationType.Failed,
										fmtMsg(CategoryManagerLocale.CategoryManagerEditTypeFail)
									);
								}
							});
					}
				}
			});
		} else {
			const form = this.$refs.editForm as FormModel;
			form.validate((valid: boolean & any, obj: any) => {
				if (valid) {
					this.saveButtonLoading = true;

					const model: EditCategoryRequestModel = {
						id: this.editedCategoryId,
						...this.editForm
					};
					this.categoryService
						.editCategory(model)
						.then(() =>
							this.fetchCategories().then(() => {
								this.onEditModalClose();
								MessageHelper.Message(
									NotificationType.Success,
									fmtMsg(CategoryManagerLocale.CategoryManagerEditCatSuc)
								);
							})
						)
						.catch(() => {
							this.saveButtonLoading = false;
							MessageHelper.Message(
								NotificationType.Failed,
								fmtMsg(CategoryManagerLocale.CategoryManagerEditCatFail)
							);
						});
				}
			});
		}
	}

	onLessonRelatedItemChange(e) {
		this.onEditingSubCategory();
		if (this.editSubCategoryModalVisible) {
			const origType = this.categories.flatMap((c) => c.types).find((t) => t.id === this.editedTypeId);
			this.showLessonRelatedItemsDeleteMsg = (origType &&
				origType.isLessonRelatedItem &&
				!e.target.checked) as boolean;
		}
	}

	onAllowRepChange(e) {
		this.onEditingSubCategory();
		let form: FormModel | null = null;
		if (this.createSubCategoryModalVisible) {
			form = this.$refs.subCategoryCreateForm as FormModel;
			if (!e.target.checked) {
				this.subCategoryCreateForm.contentGroupId = -1;
			}
		} else if (this.editSubCategoryModalVisible) {
			form = this.$refs.subCategoryEditForm as FormModel;
			if (!e.target.checked) {
				this.subCategoryEditForm.contentGroupId = -1;
			}
			const origType = this.categories.flatMap((c) => c.types).find((t) => t.id === this.editedTypeId);
			if(origType?.specialDesignationId === SpecialDesignation.VPC ||origType?.specialDesignationId === SpecialDesignation.ReviewVPC) {
				this.subCategoryEditForm.contentGroupId = ContentGroupEnum.VPC;
			}
			this.showRepDeleteMsg = (origType && origType.allowRepPlan && !e.target.checked) as boolean;
		}
		form?.validateField("contentGroupId", () => {});
	}

	onAllowTeachingPlanChange(e) {
		this.onEditingCategory();
		const checkedValue = e.target.checked;
		const origCategory = this.categories.find((c) => c.id === this.editedCategoryId);
		this.showLessonPlanDeleteMsg = (origCategory && origCategory.allowTeachingPlan && !checkedValue) as boolean;
		this.editForm.isLessonManagement = false;
	}

	onEditManageLessonPlanChange(e) {
		this.onEditingCategory();
		const checkedValue = e.target.checked;
		const origCategory = this.categories.find((c) => c.id === this.editedCategoryId);
		if (checkedValue) {
			this.editForm.isCurriculum = false;
			this.editForm.allowTeachingPlan = false;
			this.editForm.isUnitBased = true;
			this.showLessonPlanDeleteMsg = (origCategory && origCategory.allowTeachingPlan) as boolean;
		} else {
			if (origCategory) {
				this.editForm.isCurriculum = origCategory.isCurriculum;
				this.editForm.isUnitBased = origCategory.isUnitBased;
				this.editForm.allowTeachingPlan = origCategory.allowTeachingPlan;
				this.showLessonPlanDeleteMsg = false;
			}
		}
	}

	isCategoryHasContents(category: CategoryResponseModel | undefined) {
		return !!category?.hasContents;
	}

	onEditUnitBased(e) {
		this.onEditingCategory();
		const checkedValue = e.target.checked;
		const origCategory = this.categories.find((c) => c.id === this.editedCategoryId);
		this.editForm.isAbleToManageLesson = !!checkedValue;
		this.checkboxValidationState.isUnitBasedError = (this.isCategoryHasContents(origCategory) && origCategory?.isUnitBased !== checkedValue) as boolean;
	}

	onEditCurriculumChanged(e) {
		this.onEditingCategory();
		const checkedValue = e.target.checked;
		const origCategory = this.categories.find((c) => c.id === this.editedCategoryId);
		if (!checkedValue) {
			this.editForm.isAbleToManageLesson = false;
			this.editForm.isLessonManagement = false;
			this.editForm.allowTeachingPlan = false;
			this.showLessonPlanDeleteMsg = (origCategory && origCategory.allowTeachingPlan) as boolean;
		} else {
			if (origCategory) {
				this.editForm.isAbleToManageLesson = origCategory.isAbleToManageLesson;
				this.editForm.allowTeachingPlan = origCategory.allowTeachingPlan;
				this.showLessonPlanDeleteMsg = false;
			}
		}
		this.checkboxValidationState.isCurriculumError = (this.isCategoryHasContents(origCategory) && origCategory?.isCurriculum !== checkedValue) as boolean;
	}

	onCreateManageLessonPlanChange(e) {
		const checkedValue = e.target.checked;
		if (checkedValue) {
			this.createForm.isCurriculum = false;
			this.createForm.allowTeachingPlan = false;
			this.createForm.isUnitBased = true;
		}
	}

	onChangeCurriculumType(e) {
		const checkedValue = e.target.checked;
		if (!checkedValue) {
			this.createForm.isLessonManagement = false;
			this.createForm.allowTeachingPlan = false;
		}
	}

	onDeleteClick(): void {
		const isCategory = this.beingEditedOrCreated === this.ModalType.Category;
		if (isCategory) {
			const cat = this.categories.find((cat) => cat.id === this.editedCategoryId);
			if (cat?.types.length) {
				this.deleteMode = true;
				return;
			}
		}
		Modal.confirm({
			title: isCategory
				? this.format(this.Locale.CategoryManagerCatDeleteConfirmMessage)
				: this.format(this.Locale.CategoryManagerTypeDeleteConfirmMessage),
			okText: this.format(this.Locale.CategoryManagerBtnDelete),
			okType: "danger",
			onOk: () => {
				// if editing category
				if (this.beingEditedOrCreated === this.ModalType.Category) {
					//delete category and close modal after refreshing categories
					return this.categoryService
						.deleteCategory(this.editedCategoryId)
						.then(() =>
							this.fetchCategories().then(() => {
								this.onEditModalClose();
								MessageHelper.Message(
									NotificationType.Success,
									fmtMsg(CategoryManagerLocale.CategoryManagerDelCatSuc)
								);
							})
						)
						.catch((err) => {
							MessageHelper.Message(
								NotificationType.Failed,
								fmtMsg(CategoryManagerLocale.CategoryManagerDelCatFail)
							);
							return err;
						});
				} else if (this.beingEditedOrCreated === this.ModalType.Type) {
					// fetch type doc count
					this.loadingTypeDocsCount = true;
					return this.categoryService
						.getTypeDocsCount(this.editedTypeId)
						.then((count) => {
							if (count > 0) {
								this.typeDocsCount = count;
								this.loadingTypeDocsCount = false;
								this.deleteMode = true;
							} else {
								// delete type and close modal after refreshing categories
								this.deleteType(this.editedTypeId);
							}
							return count;
						})
						.catch((err) => {
							this.loadingTypeDocsCount = false;
							MessageHelper.Message(
								NotificationType.Failed,
								fmtMsg(CategoryManagerLocale.CategoryManagerFetchCountFail)
							);
							return err;
						});
				}
			}
		});
	}

	@Watch("moveForm.categoryId")
	movedocsCatChange() {
		if (this.moveForm.typeId !== undefined) {
			this.moveForm.typeId = undefined;
		}
	}

	moveDocs(deleteToo: boolean = true) {
		const form = this.$refs.moveForm as FormModel;
		form.validate((valid) => {
			if (valid) {
				this.moveButtonLoading = true;
				this.categoryService
					.moveDocuments(this.editedTypeId, this.moveForm.typeId as any)
					.then(() => {
						if (deleteToo) {
							// delete and then refresh
							this.deleteType(this.editedTypeId);
						} else {
							this.onEditModalClose();
							MessageHelper.Message(
								NotificationType.Success,
								fmtMsg(CategoryManagerLocale.CategoryManagerMoveDocSuc)
							);
						}
					})
					.catch(() => {
						this.moveButtonLoading = false;
						MessageHelper.Message(
							NotificationType.Failed,
							fmtMsg(CategoryManagerLocale.CategoryManagerMoveDocFail)
						);
					});
			}
		});
	}

	deleteType(typeId: number) {
		this.categoryService
			.deleteType(typeId)
			.then(() =>
				this.fetchCategories().then(() => {
					this.onEditModalClose();
					MessageHelper.Message(
						NotificationType.Success,
						fmtMsg(CategoryManagerLocale.CategoryManagerDelTypeSuc)
					);
				})
			)
			.catch(() => {
				this.moveButtonLoading = false;
				MessageHelper.Message(
					NotificationType.Failed,
					fmtMsg(CategoryManagerLocale.CategoryManagerDelTypeFail)
				);
			});
	}

	onEditingCategory() {
		this.enableSaveButton = true;
	}

	onEditingSubCategory() {
		this.enableSaveButton = true;
	}
}
